type Props = {
  accent: "mint" | "violet" | "cyan" | "amber" | "slate";
  shape: string[];
  iconSvg?: string | null;
  className?: string;
};

export function ToolSprite({ accent, shape, iconSvg, className }: Props) {
  if (iconSvg) {
    return (
      <span
        className={`tool-sprite tool-sprite--icon tool-sprite--${accent} ${className ?? ""}`}
        aria-hidden="true"
        dangerouslySetInnerHTML={{ __html: iconSvg }}
      />
    );
  }

  return (
    <span className={`tool-sprite tool-sprite--${accent} ${className ?? ""}`} aria-hidden="true">
      {shape.flatMap((row, rowIndex) =>
        row.split("").map((cell, columnIndex) => (
          <span
            key={`${rowIndex}-${columnIndex}`}
            className={cell === "1" ? "tool-sprite__cell is-on" : "tool-sprite__cell"}
          />
        )),
      )}
    </span>
  );
}
